<div class="dashboard-content">
  <div class="page-content">
  <!--  <div class="inner-page-title">ГЛАВНАЯ СТРАНИЦА</div>-->
    <div class="inner-page-subtitle">СЕГОДНЯ</div>
    <div class="inner-page-title">{{ currentDate.format("DD.MM.YYYY")}}</div>

    <app-events-calendar [displayPeriod]="'2weeks'" (dateChange)="onSelectedDateChange($event)"></app-events-calendar>

    <div class="events-header">Расписание на день</div>
    <app-loader *ngIf="!isLoadedEvents"></app-loader>
    <ng-container *ngIf="isLoadedEvents">
      <div class="events-container" *ngIf="events?.length; else emptyEvents">
        <ng-container *ngFor="let event of events; let ind = index">
          <div *ngIf="ind < 1" class="event-wrapper" (click)="goToEvent(event)">
            <div class="event-time">{{event.timeString}}</div>
            <div class="event-name"><b>{{event.serviceName}}</b>
              <ng-container *ngIf="event?.description && event.serviceId != '2'">: {{event?.description}}</ng-container>
              <ng-container *ngIf="event?.name && event.serviceId == '2'">: {{event?.name}}</ng-container>
            </div>
          </div>
        </ng-container>
        <div *ngIf="events.length > 1">
          <button (click)="goToEvent(events[0])"
                  class="events-show-more">Показать еще <span class="lnr lnr-chevron-right"></span>
          </button>
        </div>
      </div>
      <ng-template #emptyEvents>
        <div class="empty-block">
          <span>У вас нет расписания на день</span>
        </div>
      </ng-template>
    </ng-container>

    <div class="travels-item-header">Мои путешествия</div>
    <app-loader *ngIf="!isLoadedTravels"></app-loader>
    <ng-container *ngIf="isLoadedTravels">
      <div class="travels-list" *ngIf="travels?.length; else emptyTravels">
        <ng-container *ngFor="let travel of travels">
          <div class="travels-list-item travels-item"
               (click)="openTravelProfile($event, travel)"
               [ngStyle]="{
                       backgroundImage: 'linear-gradient(185.01deg, rgba(255, 255, 255, 0) 60.29%, rgb(255, 255, 255) 85.24%), ' + 'url(' + travel.image + ')',
                       backgroundSize: 'cover'
                   }">
            <div class="travels-item-header"> Путешествие в {{travel.locationNames}}</div>
            <div class="travels-item-dates">
              <span class="lnr lnr-calendar-full"></span>
              {{travel.dateFrom | momentDate}} -  {{travel.dateTo | momentDate}}
            </div>
            <div class="travels-item-people" *ngIf="travel.passengers?.length > 1 && travel.passengers?.length < 5">
              <span class="lnr lnr-users" ></span>
              {{travel.passengers?.length}}  человека
            </div>
            <div class="travels-item-people" *ngIf="travel.passengers?.length === 1 || travel.passengers?.length > 5">
              <span class="lnr lnr-users" ></span>
              {{travel.passengers?.length}}  человек
            </div>
          </div>
        </ng-container>
      </div>
      <ng-template #emptyTravels>
        <div class="empty-block">
          <span>У вас нет путешествий. На этой странице вы будете видеть все ваши запланированные, текущие и прошедшие путешествия</span>
        </div>
      </ng-template>
    </ng-container>

  </div>
</div>
